import request from "root/js/request";

const getPostingCancellationDiagramWarehouseOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
}) => {
  const response = await request({
    url: "/ozon_analytics/posting_cancellation/diagram/warehouse/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
    },
  });
  return response.data;
};

export { getPostingCancellationDiagramWarehouseOzon };
